import { formatInTimeZone } from "date-fns-tz";

/**
 * Whether the report's hire is still running. The payload carries no
 * `isFinal`, but a live payload for an open hire always runs to the site's
 * today, while a finished hire's ends earlier. Instants carry the camera-local
 * date in their first ten characters. Kept free of React and `@src` imports so
 * jest can test it.
 */
export function isReportLive(instants: readonly string[], siteTimezone: string, now: Date): boolean {
  const last = instants.at(-1);
  if (last === undefined) return false;
  return last.slice(0, 10) >= formatInTimeZone(now, siteTimezone, "yyyy-MM-dd");
}
